// 加油单「重新识别」口径（接入 AI 治理底座 D8 / D9），列表页与审核抽屉共用。

// D8：仅对四种未确认状态开放；「已确认」「排队识别中」不开放。须与后端 RE_EXTRACTABLE_STATUSES 一致。
export const RE_EXTRACTABLE_STATUSES = ["failed_permanent", "pending_review", "pending_review_low_confidence", "pending_review_ambiguous_match"];

// D11：批量重新识别单次上限
export const RE_EXTRACT_BATCH_MAX = 50;

// D9：「推倒重来」覆盖语义，弹窗必须明确提醒将清空未确认的字段修改与已匹配的航班。
export const RE_EXTRACT_CONFIRM_TEXT = "重新识别将清空当前未确认的字段修改与已匹配的航班，并重新调用 AI 提取字段与匹配航班，是否继续？";
export const RE_EXTRACT_QUOTA_NOTE = "每张会消耗一次 AI 识别配额。如果原因是图片本身模糊，建议先「拒绝」并重新上传更清晰的图片。";
